import React from 'react';
import { buildPrescriptionText } from '../../utils/emrHelpers';

export default function EmrVisitDetail({ visit, onClose }) {
  const rx = visit.prescription || buildPrescriptionText(visit.rxLines);

  return (
    <div className="emr-modal-backdrop" onClick={onClose} role="presentation">
      <div className="emr-modal card" onClick={(e) => e.stopPropagation()}>
        <header className="emr-modal-header">
          <div>
            <h3>{visit.patientName}</h3>
            <p className="hint">
              {visit.createdAt ? new Date(visit.createdAt).toLocaleString('en-IN') : ''} · {visit.doctorName}
            </p>
          </div>
          <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Close</button>
        </header>
        <div className="emr-modal-body">
          <section><h4>Chief complaint</h4><p>{visit.complaint || '—'}</p></section>
          {visit.hpi && (
            <section>
              <h4>HPI</h4>
              <p className="hint">
                {[visit.hpi.onset, visit.hpi.duration, visit.hpi.severity].filter(Boolean).join(' · ') || '—'}
              </p>
            </section>
          )}
          {visit.vitals && (
            <section>
              <h4>Vitals</h4>
              <p className="vitals-inline">
                {visit.vitals.bp && `BP ${visit.vitals.bp}`}
                {visit.vitals.pulse && ` · Pulse ${visit.vitals.pulse}`}
                {visit.vitals.temp && ` · Temp ${visit.vitals.temp}`}
                {visit.vitals.spo2 && ` · SpO₂ ${visit.vitals.spo2}`}
              </p>
            </section>
          )}
          <section>
            <h4>Assessment</h4>
            <p><strong>{visit.assessment?.primary || visit.diagnosis || '—'}</strong></p>
            {visit.icd10 && <p className="hint">ICD-10: {visit.icd10}</p>}
          </section>
          {rx && <section><h4>Prescription</h4><pre className="rx-pre">{rx}</pre></section>}
          {visit.investigations && <section><h4>Investigations</h4><p>{visit.investigations}</p></section>}
          {visit.plan?.advice && <section><h4>Advice</h4><p>{visit.plan.advice}</p></section>}
          {visit.soap?.subjective && (
            <section>
              <h4>SOAP</h4>
              <p><strong>S:</strong> {visit.soap.subjective}</p>
              <p><strong>O:</strong> {visit.soap.objective}</p>
              <p><strong>A:</strong> {visit.soap.assessment}</p>
              <p><strong>P:</strong> {visit.soap.plan}</p>
            </section>
          )}
        </div>
      </div>
    </div>
  );
}
